import { HimmaContext } from '../context/HimmaContext';
import { useState, useCallback, useContext } from 'react';
export const useDashboardApi = () => {
    const api = useContext(HimmaContext)!;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
  // List Coupon
    const getAllDashboard = useCallback(
        async (query: any) => {
            setLoading(true);
            setError(null);
            try {
                // Only include search parameter if it has a value
               
                const response = await api.getDashboardMetrics(
                    query.dashboardType,
                    query.fromDate,
                    query.toDate,
                   
                );
                return response.data;
            } catch (err) {
                setError(err instanceof Error ? err.message : 'An error occurred');
                throw err;
            } finally {
                setLoading(false);
            }
        },
        [api]
    );



    return {

        loading,
        error,
        getAllDashboard
    };
};
